import React from 'react';
import scrollama from 'scrollama';
import img2 from '../assets/img2.png';
import img3 from '../assets/img3.png';
import img4 from '../assets/img4.png';
import img5 from '../assets/img5.png';
import img6 from '../assets/img6.png';
import img7 from '../assets/img7.png';
import { isMobileOrTablet } from './Sections';

const Area = ({name, description, imageId, isVisible}) => {
	var bgImage =
    (typeof imageId === 'string' || imageId instanceof String) &&
    imageId.length === 36
      ? `https://outlier-spa.github.io/EstudioPinedaWeb/${imageId}.png`
      : imageId;
	var items = JSON.parse(description || '[]');
	return (
		<div className={`flex center-childs${isVisible ? ' area_visible' : ''}`}>
			<div className="area_info flex1">
				<h2 className="in_view_animate">{name}</h2>
				<div className="wp-list in_view_animate">
					<ul>
						{items.map((item, k) => (
							<li key={k}>{item}</li>
						))}
					</ul>
				</div>
			</div>
			<div className="area_image flex1">
				<div className="bg-cover" style={{backgroundImage: `url(${bgImage})`}}></div>
			</div>
		</div>
	);
}

const areasArray = [
	{
		name: 'Derecho de Familia',
		imageId: img2,
		items: [
			'Alimentos (en sus diversas modalidades).',
			'Relación directa y regular (derecho de visitas).',
			'Cuidado personal.',
			'Divorcios.',
			'Violencia intrafamiliar y medidas de protección.',
			'Acuerdos de unión civil.',
			'Adopciones.',
			'Autorizaciones para salir al exterior.',
			'Liquidaciones de regímenes matrimoniales.',
			'Redacción de contratos en general.',
			'Acciones de filiación.',
		]
	},
	{
		name: 'Derecho Civil',
		imageId: img3,
		items: [
			'Representación en diversos procesos contenciosos (indemnización de perjuicios, resolución y/o cumplimiento de contratos, arrendamientos, juicios ejecutivos, particiones, tercerías, etc.), y voluntarios (cambios de nombre, inscripción de vehículos motorizados, inscripciones forzadas al Conservador de Bienes Raíces, etc.).',
			'Representación en litigios de predios bajo el procedimiento de la ley indígena.',
			'Redacción de todo tipo de contratos.'
		]
	},
	{
		name: 'Derecho Laboral',
		imageId: img4,
		items: [
			'Representación en litigios laborales en general (despidos, tutela de Derechos Fundamentales e indemnización de perjuicios por accidentes del trabajo y enfermedades profesionales).',
			'Redacción de contratos de trabajo, reglamentos internos, etc.',
			'Auditoría generales preventivas de conflictos laborales.',
			'Término de contratos de trabajo.',
			'Asesoría general en la materia.'
		]
	},
	{
		name: 'Derecho Inmobiliario',
		imageId: img5,
		items: [
			'Adquisición y venta de inmuebles residenciales y comerciales.',
			'Proyectos inmobiliarios residenciales y comerciales, loteos, entre otros.',
			'Estudio de títulos y planos.',
			'Redacción de todo tipo de contrato relativo a la materia.',
			'Representación en transacciones, arbitrajes o litigios.'
		]
	},
	{
		name: 'Derecho Corporativo',
		imageId: img6,
		items: [
			'Constitución, estructuración y disolución de sociedades.',
			'Redacción de contratos en general.',
			'Recuperación de acreencias.',
			'Asesoría general.'
		]
	},
	{
		name: 'Otros',
		imageId: img7,
		items: [
			'Representación en litigios de Policía Local (protección del derecho del consumidor, infracciones de tránsito, indemnizaciones de perjuicio, etc.).',
			'Asesoría a deudores (eliminación DICOM, declaración de prescripción, liquidaciones voluntarias de deudor, etc.).',
			'Regularizaciones de títulos de dominio.',
			'Posesiones efectivas.',
			'Redacción de contratos en general (testamentos, usufructos, arrendamientos, etc.).'
		]
	}
];
areasArray.forEach(a => a.description = JSON.stringify(a.items));

export default class Areas extends React.Component {
	static defaultProps = { title: 'Nuestras áreas de práctica', areas: areasArray };
	constructor(props){
		super(props);
	}

	componentDidMount() {
		if (isMobileOrTablet) return;
		const scroller = scrollama();
		document.querySelectorAll('.section__area .area_image').forEach(area => {
			area.style.transform = 'translateY(-6%)';
		});
		scroller
		.setup({ step: '.section__area', progress: true, threshold: 2})
		.onStepProgress(({element, progress}) => {
			var style = `translateY(${progress*12 - 6}%)`;
			element.querySelector('.area_image').style.transform = style;
		});
	}

	render(){
		var { title, areas } = this.props;
		return (
			<section className="wp-section-areas">
				<div>
					<div className="inner__section">
						<div className="section__areas">
							<div className="center-text">
								<h2 className="section__title inverse in_view_animate">{title}</h2>
							</div>
							{ areas.map((area, k) => (
								<div className="section__area" key={k}>
									<Area {...area} />
								</div>
							)) }
						</div>
					</div>
				</div>
			</section>
		);
	}
}
